import React from 'react'
import couponDescriptions from '../../couponDescriptions.js'


class UpgradeDiscountSash extends React.Component{

	render(){	
		const couponDescription=couponDescriptions[process.env.REACT_APP_DEFAULT_COUPON_CODE]

		return(
			
			<div className='upgrade--introDiscountSashContainer'>
				<div className='upgrade--introDiscountSash'>
					<div className='upgrade--introDiscountSash-title'>
							Save 45%
						</div>
						<div className='upgrade--introDiscountSash-sub'>
							with an annual plan until {couponDescription.until}
						</div>
					{/* 
						<div className='upgrade--introDiscountSash-title'>
							{couponDescription.percentage}% off
						</div>
						<div className='upgrade--introDiscountSash-sub'>
							annual plans until {couponDescription.until}							
						</div>
					*/}
				</div>
			</div>

		)	
	}
				
}

export default UpgradeDiscountSash





// WEBPACK FOOTER //
// ./src/components/upgrade/UpgradeDiscountSash.js